import { axiosInstance } from ".";

/** PROLINE-4136 — every subscription plan, with `price_per_year`, cheapest first (PROLINE-4150). */
const getSubscriptionPlans = async (config) =>
  await axiosInstance.get("/subscription_plans", config);

/**
 * PROLINE-4150 — the plans priced above the company's current plan, cheapest first, every
 * page at once: the options of "Upgrade Subscription Plan".
 */
const getUpgradeSubscriptionPlans = async (currentPlanId, config) =>
  await axiosInstance.get("/subscription_plans", {
    ...config,
    params: { bigger_than_subscription_plan_id: currentPlanId, page: -1 },
  });

export { getSubscriptionPlans, getUpgradeSubscriptionPlans };
